import styled from 'styled-components';

import { Button, ButtonSizes } from '@calm-web/design-system';

// Transparent rather than the bordered/filled treatment FaveHeart offers via its $withBorder
// prop: both platforms draw this header heart as a bare glyph over the hero backdrop, with no
// scrim circle behind it (iOS's fave button theme drops the circle for exactly this placement).
export const Wrapper = styled(Button).attrs({
	color: 'white',
	backgroundColor: 'transparent',
	size: ButtonSizes.Sm,
})``;
